import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// Parental Control calls (sheet module 1). Every call needs the signed-in user's token.
const url = (path) => `${API_BASE_URL}/parental/${path}`;
const config = () => ({ headers: { token: getAuthToken(), "Content-Type": "application/json" }, timeout: 15000 });
const result = (r) => r.data?.result;

export const parentalApi = {
  // linking (phase 1)
  me: () => axios.get(url("me"), config()).then(result),
  createCode: () => axios.post(url("codes"), {}, config()).then(result),
  link: (code) => axios.post(url("link"), { code }, config()).then(result),
  remove: (id) => axios.post(url(`links/${id}/remove`), {}, config()).then(result),
  // time limits (phase 2): the teen's status and heartbeat, and the parent's rules for one teen
  usage: () => axios.get(url("usage"), config()).then(result),
  heartbeat: () => axios.post(url("usage/heartbeat"), {}, config()).then(result),
  limits: (childId) => axios.get(url(`children/${childId}/limits`), config()).then(result),
  saveLimits: (childId, body) => axios.put(url(`children/${childId}/limits`), body, config()).then(result),
  // spending allowance (phase 3): the teen's own status, and the parent's read and save for one teen
  allowance: () => axios.get(url("allowance"), config()).then(result),
  childAllowance: (childId) => axios.get(url(`children/${childId}/allowance`), config()).then(result),
  // activity summary (row 1.4.3): the last 7 days for every linked teen
  summary: () => axios.get(url("summary"), config()).then(result),
  // requests: a teen asks a parent for more time or more money; any one parent answers
  requests: () => axios.get(url("requests"), config()).then(result),
  askFor: (body) => axios.post(url("requests"), body, config()).then(result),
  cancelRequest: (id) => axios.post(url(`requests/${id}/cancel`), {}, config()).then(result),
  decideRequest: (id, decision) => axios.post(url(`requests/${id}/decide`), { decision }, config()).then(result),
  saveAllowance: (childId, monthlyAmount) => axios.put(url(`children/${childId}/allowance`), { monthly_amount: monthlyAmount }, config()).then(result),
};
